import type { SankeyShape } from '../types/sankey-shape.js';

export function isSameSankeyShape(
  prev: SankeyShape | undefined,
  next: SankeyShape | undefined,
): boolean {
  if (prev === next) {
    return true;
  }
  if (prev === undefined || next === undefined) {
    return false;
  }
  if (prev.type === 'node' && next.type === 'node') {
    return prev.nodeId === next.nodeId;
  }
  if (prev.type === 'link' && next.type === 'link') {
    return (
      prev.sourceId === next.sourceId &&
      prev.targetId === next.targetId &&
      prev.linkIndex === next.linkIndex
    );
  }
  return false;
}
